import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, "Add Episode", -1)
const _hoisted_2 = { class: "space-y-2 mb-4 max-h-[calc(100vh-20rem)] overflow-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Episode", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Link", -1)
const _hoisted_5 = { class: "flex items-center justify-end gap-2" }

import { Button, Divider, Input, Modal } from 'ant-design-vue';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { HttpStatusCode } from 'axios';
import { createHentaiEpisode } from '@/repository/hentai';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddEpisode',
  props: {
    hentaiUUID: {},
    isOpened: { type: Boolean },
    onClose: { type: Function }
  },
  emits: ["onBeforeClose"],
  setup(__props: any, { emit }) {

const props = __props;





const store = useStore();

const isAdding = ref(false);

const form = ref({
	episode: 0,
	link: ''
});

async function submit() {
	if (`${form.value.episode}`.length === 0 || form.value.link.length === 0 || isAdding.value) {
		return;
	}
	try {
		isAdding.value = true;
		const res = await createHentaiEpisode(
			props.hentaiUUID,
			form.value.episode.toString(),
			form.value.link
		);
		if (res.status !== HttpStatusCode.Ok && res.status !== HttpStatusCode.Created) {
			if (res.status === HttpStatusCode.Conflict) {
				throw Error('This episode has been added');
			}
			throw Error('Invalid link');
		}
		await emit('onBeforeClose');
		store.dispatch('alert', { type: 'success', message: 'Add new episode successfully!' });
		close();
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isAdding.value = false;
	}
}

function close() {
	isAdding.value = false;
	form.value = {
		episode: 0,
		link: ''
	};
	props.onClose();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    open: _ctx.isOpened,
    closable: false
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createVNode(_unref(Divider), { class: "p-0 my-4" })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Divider), { class: "p-0 my-4" }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Button), {
          key: "back",
          onClick: close,
          disabled: isAdding.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          key: "submit",
          type: "primary",
          disabled: `${form.value.episode}`.length === 0 || form.value.link.length === 0 || isAdding.value,
          onClick: submit
        }, _createSlots({
          default: _withCtx(() => [
            _createTextVNode(" OK ")
          ]),
          _: 2
        }, [
          (isAdding.value)
            ? {
                name: "icon",
                fn: _withCtx(() => [
                  _createVNode(_unref(LoadingOutlined))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_unref(Input), {
            type: "number",
            value: form.value.episode,
            min: 0,
            max: 999,
            disabled: isAdding.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (form.value.episode = +$event.target.value!))
          }, null, 8, ["value", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_unref(Input), {
            value: form.value.link,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.link) = $event)),
            placeholder: "Enter link",
            disabled: isAdding.value
          }, null, 8, ["value", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})